import { Division, Span, Flex, Heading, Popover, Button, Icon, Icons } from "@ir/ui";
import { useCallback, useMemo } from "react";
import { ApprovalFilterForm } from "./ApprovalFilterForm";

interface ApprovalFilterProps {
  isOpenFilterPopover: boolean;
  setIsOpenFilterPopover: (isOpen: boolean) => void;
  filterRef: React.RefObject<HTMLDivElement | null>;
}

const ApprovalFilterPopover = ({ isOpenFilterPopover, setIsOpenFilterPopover, filterRef }: ApprovalFilterProps) => {
  const handleFilterOn = useCallback(() => {
    const filterButtonContainer = document.getElementById("filter-trigger");
    if (filterButtonContainer && isOpenFilterPopover === false) {
      filterButtonContainer.blur();
    }
    setIsOpenFilterPopover(true);
  }, [isOpenFilterPopover, setIsOpenFilterPopover]);

  const popoverTitle = useMemo(() => {
    return (
      <Flex align="start" justifyContent="space-between" className="px-2">
        <Division>
          <Heading level={5} className="text-primary-900 m-0 font-bold">
            Filters
          </Heading>
          <Span className="sub-title text-grey-500 text-sm">Apply filters to table data</Span>
        </Division>
        <Button variant="clear" color="grey" onPress={() => setIsOpenFilterPopover(false)} noStyle>
          <Icon name={Icons.Close} size="medium" style={{ color: "var(--grey-300)" }} />
        </Button>
      </Flex>
    );
  }, [setIsOpenFilterPopover]);

  const handleOnOpenChange = useCallback(
    (open: boolean) => {
      setIsOpenFilterPopover(open);
    },
    [setIsOpenFilterPopover]
  );

  return (
    <Popover
      ref={filterRef}
      isOpen={isOpenFilterPopover}
      placement="bottom right"
      className="filter-popover"
      isNonModal={true}
      shouldCloseOnInteractOutside={() => true}
      title={popoverTitle}
      onOpenChange={handleOnOpenChange}
      content={
        <Division className="filter-popover-content p-2" ref={filterRef}>
          <ApprovalFilterForm closeFilter={() => setIsOpenFilterPopover(false)} />
        </Division>
      }
    >
      <Button
        noStyle
        className="filter-trigger-button"
        id="filter-trigger"
        onPress={handleFilterOn}
        aria-label="Open filter options"
        htmlTitle="Open Filter Options"
      >
        <Icon name={Icons.FilterLines} size="small" color="grey" />
      </Button>
    </Popover>
  );
};

export { ApprovalFilterPopover };
